import { resolveProductCategoryByPath } from '@/router/pageConst'
import { useLocation } from 'react-router-dom'

function useProductType() {
  const location = useLocation()
  const productType = resolveProductCategoryByPath(location.pathname)
  return { productType }
}


export default useProductType
